import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";


export const getDashboardCount = createAsyncThunk(
    "community/getDashboardCount",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.get("community/dashboard-count");
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response ? error.response.data : error.message
        );
      }
    }
  );
  